module.exports = __webpack_public_path__ + "partnership-financial-pre-authorized-payment-methods-confirmation.modal.html";


//////////////////
// WEBPACK FOOTER
// ./vendor/app-core/action-modal/partnership-financial-pre-authorized-payment-methods-confirmation.modal.html
// module id = 478
// module chunks = 0